import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { sellerApi } from "src/app/config";
import { ApiService } from "./api.service";
import {  BehaviorSubject } from 'rxjs'
@Injectable({
  providedIn: "root",
})
export class CreatePromotionService {
  constructor(private apiService: ApiService) {}

  ciscoAdminChallenge=new BehaviorSubject<any>(null);
  setCiscoAdminData(data){
    this.ciscoAdminChallenge.next({editData:data})
  };
  getCiscoAdminData(){
    return this.ciscoAdminChallenge.asObservable();
  };
  getCreationPromotionData() {
    let challengeData = this.ciscoAdminChallenge.value;
    if(challengeData != null && challengeData.editData != null && !challengeData.editData.hasOwnProperty('copy')){
      return  this.apiService.get(`${sellerApi.customChallenge}${this.ciscoAdminChallenge.value.editData['id']}`);
    } else if (challengeData != null && challengeData.editData != null && challengeData.editData.hasOwnProperty('copy')) {
      return  this.apiService.get(`${sellerApi.cloneChallenge}${this.ciscoAdminChallenge.value.editData['id']}`);
    } else {
      return this.apiService.get(`${sellerApi.customChallenge}${'new'}`);
    };

    // return of({
    //   "questions": [
    //     {
    //       "id": 1,
    //       "orderNumber": 1,
    //       "type": "NON_TEMPLATED",
    //       "text": "What is the Sales Challenge NAME?",
    //       "hint": "This is the name that will be displayed, referred and officially recorded to identify this challenge.",
    //       "info": "STATIC",
    //       "formFieldType": "TEXTBOX",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": null,
    //       "isRequired": true,
    //       "allowExcelFileUpload": false,
    //       "identifier": "name"
    //     },
    //     {
    //       "id": 2,
    //       "orderNumber": 2,
    //       "type": "NON_TEMPLATED",
    //       "text": "What is the Sales Challenge DESCRIPTION?",
    //       "hint": "This is a short description of the challenge.  It is meant to inform participants of the key challenge goals and requirements.",
    //       "info": "STATIC",
    //       "formFieldType": "TEXTAREA",
    //       "formFieldFormat": "LONG_TEXT",
    //       "questionCondition": null,
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "description"
    //     },
    //     {
    //       "id": 3,
    //       "orderNumber": 3,
    //       "type": "NON_TEMPLATED",
    //       "text": "What is the Sales Challenge REWARDS (per eligible order)?",
    //       "hint": "This is the highest amount that can be rewarded for an eligible sales order, i.e. 500,000 points, 1.0% of net sales value, up to 200,000 points, etc.  Do not enter dollar amounts.",
    //       "info": "STATIC",
    //       "formFieldType": "TEXTAREA",
    //       "formFieldFormat": "LONG_TEXT",
    //       "questionCondition": null,
    //       "isRequired": true,
    //       "allowExcelFileUpload": false,
    //       "identifier": "shortDescription"
    //     },
    //     {
    //       "id": 4,
    //       "orderNumber": 4,
    //       "type": "NON_TEMPLATED",
    //       "text": "What is the Sales Challenge eligible FISCAL YEAR?",
    //       "hint": "This is the Cisco fiscal year in which the sales order must have been booked to qualify for the Sales Challenge Rewards.",
    //       "info": "STATIC",
    //       "formFieldType": "DROPDOWN",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": null,
    //       "isRequired": true,
    //       "allowExcelFileUpload": false,
    //       "identifier": "fiscalYear"
    //     },
    //     {
    //       "id": 5,
    //       "orderNumber": 5,
    //       "type": "NON_TEMPLATED",
    //       "text": "What is the Sales Challenge eligible FISCAL QUARTERS?",
    //       "hint": "This is the Cisco fiscal quarter in which the sales order must have been booked to qualify for the Sales Challenge Rewards.",
    //       "info": "STATIC",
    //       "formFieldType": "DROPDOWN",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": null,
    //       "isRequired": true,
    //       "allowExcelFileUpload": false,
    //       "identifier": "quarter"
    //     },
    //     {
    //       "id": 6,
    //       "orderNumber": 6,
    //       "type": "NON_TEMPLATED",
    //       "text": "What are the Sales Challenge eligible START/END DATES?",
    //       "hint": "These are the dates in which the sales orders must have been booked to qualify for the Sales Challenge Rewards.",
    //       "info": "STATIC",
    //       "formFieldType": "DATEPICKER",
    //       "formFieldFormat": "DATE",
    //       "questionCondition": null,
    //       "isRequired": true,
    //       "allowExcelFileUpload": false,
    //       "identifier": "startDate"
    //     },
    //     {
    //       "id": 8,
    //       "orderNumber": 7,
    //       "type": "NON_TEMPLATED",
    //       "text": "What is the Sales Challenge Unique Identifier?",
    //       "hint": "The Sales Challenge Unique Identifier is used to find, review or officially reference this challenge. Please make and keep note of it.",
    //       "info": "STATIC",
    //       "formFieldType": "TEXTBOX",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": null,
    //       "isRequired": true,
    //       "allowExcelFileUpload": false,
    //       "identifier": "acronym"
    //     },
    //     {
    //       "id": 7,
    //       "orderNumber": 8,
    //       "type": "NON_TEMPLATED",
    //       "text": "Please provide the emails of the approvers (provide each email in a new line)",
    //       "hint": null,
    //       "info": "STATIC",
    //       "formFieldType": "TEXTAREA_LIST",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": null,
    //       "isRequired": true,
    //       "allowExcelFileUpload": false,
    //       "identifier": "approverEmails"
    //     },
    //     {
    //       "id": 9,
    //       "orderNumber": 9,
    //       "type": "NON_TEMPLATED",
    //       "text": "Which REGIONS are eligible to participate in the Sales Challenge?",
    //       "hint": null,
    //       "info": "STATIC",
    //       "formFieldType": "CHECKBOX",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": "IN",
    //       "isRequired": true,
    //       "allowExcelFileUpload": false,
    //       "identifier": "regions"
    //     },
    //     {
    //       "id": 10,
    //       "orderNumber": 10,
    //       "type": "NON_TEMPLATED",
    //       "text": "Which COUNTRIES in the selected region are NOT eligible to participate in the Sales Challenge?",
    //       "hint": "Enter any countries within the selected Regions that are NOT eligible to participate in the Sales Challenge.  If all countries are eligible to participate in the Sales Challenge, leave this field blank.",
    //       "info": "CRITERIA",
    //       "formFieldType": "TEXTBOX",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": "IN",
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "COUNTRY"
    //     },
    //     {
    //       "id": 11,
    //       "orderNumber": 11,
    //       "type": "NON_TEMPLATED",
    //       "text": "Which Partner CERTIFICATIONS are eligible to participate in the Sales Challenge?",
    //       "hint": null,
    //       "info": "CRITERIA",
    //       "formFieldType": "CHECKBOX",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": "IN",
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "PARTNER_CERTIFICATION"
    //     },
    //     {
    //       "id": 12,
    //       "orderNumber": 12,
    //       "type": "NON_TEMPLATED",
    //       "text": "Which Partner SPECIALIZATIONS are required to participate in the Sales Challenge",
    //       "hint": "Enter a Cisco Specialization only if it is required of the Partner/Seller to qualify for the Sales Challenge Rewards.  Otherwise, leave this field blank.",
    //       "info": "CRITERIA",
    //       "formFieldType": "TEXTBOX",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": "IN",
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "PARTNER_SPECIALIZATION"
    //     },
    //     {
    //       "id": 13,
    //       "orderNumber": 13,
    //       "type": "NON_TEMPLATED",
    //       "text": "Which PARTNERS (BE GEO ID) are eligible to participate in the Sales Challenge?",
    //       "hint": "Eligible Partners Sellers can view, participate and earn Rewards from the Sales Challenge. If all Partners are NOT eligible, you must create and upload a list (MS Excel) of the select group of Partners (BE GEO ID) that are eligible to participate in the Sales Challenge. Eligible Partners must meet all Sales Challenge requirements to qualify for Rewards.",
    //       "info": "CRITERIA",
    //       "formFieldType": "CHECKBOX",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": "IN",
    //       "isRequired": false,
    //       "allowExcelFileUpload": true,
    //       "identifier": "BEGEOID"
    //     },
    //     {
    //       "id": 14,
    //       "orderNumber": 14,
    //       "type": "NON_TEMPLATED",
    //       "text": "Which Partner/Seller ROLES are eligible to participate in the Sales Challenge?",
    //       "hint": null,
    //       "info": "CRITERIA",
    //       "formFieldType": "CHECKBOX",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": "IN",
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "USER_ROLE"
    //     },
    //     {
    //       "id": 15,
    //       "orderNumber": 15,
    //       "type": "NON_TEMPLATED",
    //       "text": "How many Partner/Seller roles are eligible for REWARDS per eligible sales order claimed?",
    //       "hint": "This is the number of persons (per role) that will receive Rewards per eligible order claimed.",
    //       "info": "CRITERIA",
    //       "formFieldType": "TEXTBOX",
    //       "formFieldFormat": "INTEGER",
    //       "questionCondition": "LESSER_THAN_OR_EQUAL_TO",
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "CLAIMS_LIMIT"
    //     },
    //     {
    //       "id": 16,
    //       "orderNumber": 16,
    //       "type": "NON_TEMPLATED",
    //       "text": "Which Cisco SCMS customer segments are eligible for the Sales Challenge?",
    //       "hint": "Public Sector accounts are not eligible for Seller Rewards.",
    //       "info": "CRITERIA",
    //       "formFieldType": "CHECKBOX",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": "IN",
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "SCMS"
    //     },
    //     {
    //       "id": 17,
    //       "orderNumber": 17,
    //       "type": "NON_TEMPLATED",
    //       "text": "Which Cisco SUB SCMS customer segments are eligible for the Sales Challenge?",
    //       "hint": "Public Sector accounts are not eligible for Seller Rewards.",
    //       "info": "CRITERIA",
    //       "formFieldType": "CHECKBOX",
    //       "formFieldFormat": "INTEGER",
    //       "questionCondition": "IN",
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "SUB_SCMS"
    //     },
    //     {
    //       "id": 18,
    //       "orderNumber": 18,
    //       "type": "NON_TEMPLATED",
    //       "text": "Which CUSTOMERS (Global HQ ID) are eligible for the Sales Challenge?",
    //       "hint": "Public Sector accounts are not eligible for Seller Rewards. If all Customers are NOT eligible, you must create and upload a list (MS Excel) of the select group of Customers (Global HQ ID) that are eligible for the Sales Challenge.",
    //       "info": "CRITERIA",
    //       "formFieldType": "CHECKBOX",
    //       "formFieldFormat": "INTEGER",
    //       "questionCondition": "IN",
    //       "isRequired": false,
    //       "allowExcelFileUpload": true,
    //       "identifier": "END_CUSTOMER_ID"
    //     },
    //     {
    //       "id": 19,
    //       "orderNumber": 19,
    //       "type": "NON_TEMPLATED",
    //       "text": "Is Cisco SalesConnect Training required to qualify for Sales Challenge Rewards?",
    //       "hint": "Please Select or Enter (if not listed) the required SalesConnect Training info (Course ID or Learning Map number).",
    //       "info": "CRITERIA",
    //       "formFieldType": "CHECKBOX",
    //       "formFieldFormat": "TEXT",
    //       "questionCondition": "IN",
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "TRAINING_ACTIVITY"
    //     },
    //     {
    //       "id": 24,
    //       "orderNumber": 20,
    //       "type": "TEMPLATED",
    //       "text": "I want to reward for ##1##. The deal should have ##2## that is ##3##",
    //       "hint": null,
    //       "info": "CRITERIA",
    //       "formFieldType": null,
    //       "formFieldFormat": null,
    //       "questionCondition": "IN",
    //       "isRequired": true,
    //       "allowExcelFileUpload": false,
    //       "identifier": "TEMPLATED_CRITERIA"
    //     },
    //     {
    //       "id": 25,
    //       "orderNumber": 21,
    //       "type": "TEMPLATED",
    //       "text": "I want to pay in ##1## against ##2## as per the below ranges:",
    //       "hint": null,
    //       "info": "CRITERIA",
    //       "formFieldType": null,
    //       "formFieldFormat": null,
    //       "questionCondition": "IN",
    //       "isRequired": true,
    //       "allowExcelFileUpload": false,
    //       "identifier": "TEMPLATED_PAYOUT"
    //     },
    //     {
    //       "id": 20,
    //       "orderNumber": 22,
    //       "type": "NON_TEMPLATED",
    //       "text": "What is the TOTAL BUDGET available for the Sales Challenge?",
    //       "hint": "This is the total amount of budget available for all eligible regions and quarter periods.",
    //       "info": "BUDGET_CAP",
    //       "formFieldType": "TEXTBOX",
    //       "formFieldFormat": "CURRENCY",
    //       "questionCondition": null,
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "BUDGETCAP_GLOBAL"
    //     },
    //     {
    //       "id": 21,
    //       "orderNumber": 23,
    //       "type": "NON_TEMPLATED",
    //       "text": "What is the REGIONAL QUARTERLY BUDGET available for the Sales Challenge?",
    //       "hint": "This is the total amount of budget available per eligible region and quarter period.",
    //       "info": "BUDGET_CAP",
    //       "formFieldType": "TEXTBOX",
    //       "formFieldFormat": "CURRENCY",
    //       "questionCondition": null,
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "BUDGETCAP_REGIONAL"
    //     },
    //     {
    //       "id": 22,
    //       "orderNumber": 24,
    //       "type": "NON_TEMPLATED",
    //       "text": "What is the PARTNER CAP for the Sales Challenge?",
    //       "hint": "This is the maximum amount that can be issued to the Partner for the Challenge.  No Rewards can be earned or issued once this amount has been reached by a Partner. Enter 0, if there is no Partner cap.",
    //       "info": "BUDGET_CAP",
    //       "formFieldType": "TEXTBOX",
    //       "formFieldFormat": "CURRENCY",
    //       "questionCondition": null,
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "BUDGETCAP_PARTNER"
    //     },
    //     {
    //       "id": 23,
    //       "orderNumber": 25,
    //       "type": "NON_TEMPLATED",
    //       "text": "What is the SELLER REWARDS CAP for the Sales Challenge?",
    //       "hint": "This is the maximum amount that can be Rewarded to a Seller for the Challenge.  No Rewards can be earned or rewarded once this amount has been reached by a Seller. Enter 0, if there is no Seller cap.",
    //       "info": "BUDGET_CAP",
    //       "formFieldType": "TEXTBOX",
    //       "formFieldFormat": "CURRENCY",
    //       "questionCondition": null,
    //       "isRequired": false,
    //       "allowExcelFileUpload": false,
    //       "identifier": "BUDGETCAP_INDIVIDUAL"
    //     }
    //   ],
    //   "possibleValues": {
    //     "SCMS": [
    //       {
    //         "label": "All",
    //         "value": "ALL"
    //       },
    //       {
    //         "label": "COMMERCIAL",
    //         "value": "COMMERCIAL"
    //       },
    //       {
    //         "label": "ENTERPRISE",
    //         "value": "ENTERPRISE"
    //       },
    //       {
    //         "label": "SERVICE PROVIDER",
    //         "value": "SERVICE PROVIDER"
    //       },
    //       {
    //         "label": "SMALL",
    //         "value": "SMALL"
    //       },
    //       {
    //         "label": "OTHER",
    //         "value": "OTHER"
    //       }
    //     ],
    //     "SUB_SCMS": [
    //       {
    //         "label": "All",
    //         "value": "ALL"
    //       },
    //       {
    //         "label": "OTH-OTHER",
    //         "value": "OTH-OTHER"
    //       },
    //       {
    //         "label": "COM-OTHER",
    //         "value": "COM-OTHER"
    //       },
    //       {
    //         "label": "ENT-OTHER",
    //         "value": "ENT-OTHER"
    //       },
    //       {
    //         "label": "SP-OTHER",
    //         "value": "SP-OTHER"
    //       },
    //       {
    //         "label": "SP-MAJOR",
    //         "value": "SP-MAJOR"
    //       },
    //       {
    //         "label": "ENT-KEY",
    //         "value": "ENT-KEY"
    //       },
    //       {
    //         "label": "ENT-PERMIER",
    //         "value": "ENT-PERMIER"
    //       },
    //       {
    //         "label": "COM-MIDSIZE",
    //         "value": "COM-MIDSIZE"
    //       },
    //       {
    //         "label": "COM-SMALL",
    //         "value": "COM-SMALL"
    //       },
    //       {
    //         "label": "COM-SELECT",
    //         "value": "COM-SELECT"
    //       },
    //       {
    //         "label": "ENT-MAJOR",
    //         "value": "ENT-MAJOR"
    //       },
    //       {
    //         "label": "SP-KEY",
    //         "value": "SP-KEY"
    //       }
    //     ],
    //     "PARTNER_CERTIFICATION": [
    //       {
    //         "label": "All Certifications",
    //         "value": "ALL CERTIFICATIONS"
    //       },
    //       {
    //         "label": "Registered",
    //         "value": "REGISTERED"
    //       },
    //       {
    //         "label": "Select",
    //         "value": "SELECT"
    //       },
    //       {
    //         "label": "Premier",
    //         "value": "PREMIER"
    //       },
    //       {
    //         "label": "Gold",
    //         "value": "GOLD"
    //       }
    //     ],
    //     "TEMPLATED_PAYOUT": [
    //       {
    //         "label": "percentage",
    //         "value": "PERCENTAGE",
    //         "possibleValues": [
    //           {
    //             "formFieldFormat": "TEXT",
    //             "label": "individual products",
    //             "value": "PAY_AGAINST_PRODUCTS",
    //             "id": 180
    //           },
    //           {
    //             "formFieldFormat": "TEXT",
    //             "label": "eligible products booking amount",
    //             "value": "PAY_AGAINST_ELIGIBLE_PRODUCTS_BOOKING_AMOUNT",
    //             "id": 179
    //           },
    //           {
    //             "formFieldFormat": "TEXT",
    //             "label": "booking amount of the order",
    //             "value": "PAY_AGAINST_PO_BOOKING_AMOUNT",
    //             "id": 178
    //           }
    //         ]
    //       },
    //       {
    //         "label": "points",
    //         "value": "POINTS",
    //         "possibleValues": [
    //           {
    //             "formFieldFormat": "TEXT",
    //             "label": "individual products",
    //             "value": "PAY_AGAINST_PRODUCTS",
    //             "id": 184
    //           },
    //           {
    //             "formFieldFormat": "TEXT",
    //             "label": "eligible products booking amount",
    //             "value": "PAY_AGAINST_ELIGIBLE_PRODUCTS_BOOKING_AMOUNT",
    //             "id": 183
    //           },
    //           {
    //             "formFieldFormat": "TEXT",
    //             "label": "booking amount of the order",
    //             "value": "PAY_AGAINST_PO_BOOKING_AMOUNT",
    //             "id": 182
    //           }
    //         ]
    //       }
    //     ],
    //     "USER_ROLE": [
    //       {
    //         "label": "Account Manager",
    //         "value": "ACCT_MANAGER"
    //       },
    //       {
    //         "label": "Sales/System Engineers",
    //         "value": "SALES_ENGINEER"
    //       }
    //     ],
    //     "TEMPLATED_CRITERIA": [
    //       {
    //         "label": "sales",
    //         "value": "SALES",
    //         "possibleValues": [
    //           {
    //             "formFieldFormat": "TEXT",
    //             "label": "product family",
    //             "value": "SKU_FAMILY",
    //             "possibleValues": [
    //               {
    //                 "label": "In",
    //                 "value": "IN",
    //                 "id": 197
    //               }
    //             ],
    //             "id": 196
    //           },
    //           {
    //             "formFieldFormat": "TEXT",
    //             "label": "product",
    //             "value": "SKU",
    //             "possibleValues": [
    //               {
    //                 "label": "In",
    //                 "value": "IN",
    //                 "id": 195
    //               }
    //             ],
    //             "id": 194
    //           },
    //           {
    //             "formFieldFormat": "CURRENCY",
    //             "label": "booking amount",
    //             "value": "BOOKING_AMOUNT",
    //             "possibleValues": [
    //               {
    //                 "label": "lesser than",
    //                 "value": "LESSER_THAN",
    //                 "id": 193
    //               },
    //               {
    //                 "label": "lesser than or equal to",
    //                 "value": "LESSER_THAN_OR_EQUAL_TO",
    //                 "id": 192
    //               },
    //               {
    //                 "label": "equal to",
    //                 "value": "EQUALS",
    //                 "id": 191
    //               },
    //               {
    //                 "label": "greater than",
    //                 "value": "GREATER_THAN",
    //                 "id": 190
    //               },
    //               {
    //                 "label": "greater than or equal to",
    //                 "value": "GREATER_THAN_OR_EQUAL_TO",
    //                 "id": 189
    //               }
    //             ],
    //             "id": 188
    //           }
    //         ]
    //       }
    //     ],
    //     "fiscalYear": [
    //       {
    //         "label": "2022",
    //         "value": "2022",
    //         "possibleValues": [
    //           {
    //             "formFieldFormat": "DATE",
    //             "label": "Q4",
    //             "value": "Q4",
    //             "possibleValues": [
    //               {
    //                 "label": "End Date",
    //                 "value": "2022-07-30",
    //                 "id": 210
    //               },
    //               {
    //                 "label": "Start Date",
    //                 "value": "2022-05-01",
    //                 "id": 209
    //               }
    //             ],
    //             "id": 208
    //           },
    //           {
    //             "formFieldFormat": "DATE",
    //             "label": "Q3",
    //             "value": "Q3",
    //             "possibleValues": [
    //               {
    //                 "label": "End Date",
    //                 "value": "2022-04-30",
    //                 "id": 207
    //               },
    //               {
    //                 "label": "Start Date",
    //                 "value": "2022-01-30",
    //                 "id": 206
    //               }
    //             ],
    //             "id": 205
    //           },
    //           {
    //             "formFieldFormat": "DATE",
    //             "label": "Q2",
    //             "value": "Q2",
    //             "possibleValues": [
    //               {
    //                 "label": "End Date",
    //                 "value": "2022-01-29",
    //                 "id": 204
    //               },
    //               {
    //                 "label": "Start Date",
    //                 "value": "2021-10-31",
    //                 "id": 203
    //               }
    //             ],
    //             "id": 202
    //           },
    //           {
    //             "formFieldFormat": "DATE",
    //             "label": "Q1",
    //             "value": "Q1",
    //             "possibleValues": [
    //               {
    //                 "label": "End Date",
    //                 "value": "2021-10-30",
    //                 "id": 201
    //               },
    //               {
    //                 "label": "Start Date",
    //                 "value": "2021-08-01",
    //                 "id": 200
    //               }
    //             ],
    //             "id": 199
    //           }
    //         ]
    //       },
    //       {
    //         "label": "2023",
    //         "value": "2023",
    //         "possibleValues": [
    //           {
    //             "formFieldFormat": "DATE",
    //             "label": "Q4",
    //             "value": "Q4",
    //             "possibleValues": [
    //               {
    //                 "label": "End Date",
    //                 "value": "2023-07-29",
    //                 "id": 223
    //               },
    //               {
    //                 "label": "Start Date",
    //                 "value": "2023-04-30",
    //                 "id": 222
    //               }
    //             ],
    //             "id": 221
    //           },
    //           {
    //             "formFieldFormat": "DATE",
    //             "label": "Q3",
    //             "value": "Q3",
    //             "possibleValues": [
    //               {
    //                 "label": "End Date",
    //                 "value": "2023-04-29",
    //                 "id": 220
    //               },
    //               {
    //                 "label": "Start Date",
    //                 "value": "2023-01-29",
    //                 "id": 219
    //               }
    //             ],
    //             "id": 218
    //           },
    //           {
    //             "formFieldFormat": "DATE",
    //             "label": "Q2",
    //             "value": "Q2",
    //             "possibleValues": [
    //               {
    //                 "label": "End Date",
    //                 "value": "2023-01-28",
    //                 "id": 217
    //               },
    //               {
    //                 "label": "Start Date",
    //                 "value": "2022-10-30",
    //                 "id": 216
    //               }
    //             ],
    //             "id": 215
    //           },
    //           {
    //             "formFieldFormat": "DATE",
    //             "label": "Q1",
    //             "value": "Q1",
    //             "possibleValues": [
    //               {
    //                 "label": "End Date",
    //                 "value": "2022-10-29",
    //                 "id": 214
    //               },
    //               {
    //                 "label": "Start Date",
    //                 "value": "2022-07-31",
    //                 "id": 213
    //               }
    //             ],
    //             "id": 212
    //           }
    //         ]
    //       }
    //     ],
    //     "regions": [
    //       {
    //         "label": "LATAM",
    //         "value": "LATAM"
    //       },
    //       {
    //         "label": "APJC",
    //         "value": "APJ"
    //       },
    //       {
    //         "label": "USA",
    //         "value": "USA"
    //       },
    //       {
    //         "label": "CANADA",
    //         "value": "CANADA"
    //       }
    //     ]
    //   },
    //   "customChallenge": {
    //     "id": null,
    //     "name": null,
    //     "description": null,
    //     "shortDescription": null,
    //     "acronym": null,
    //     "identifier": null,
    //     "startDate": null,
    //     "endDate": null,
    //     "regions": [],
    //     "quarter": null,
    //     "fiscalYear": null,
    //     "status": "DRAFT",
    //     "approvedOn": null,
    //     "approverEmails": null,
    //     "budgetCaps": [],
    //     "attachments": null,
    //     "challengeCriteria": {
    //       "type": "GROUP",
    //       "logicalConditionBetweenChildCriterias": "AND",
    //       "criterias": [
    //         {
    //           "type": "SINGLE",
    //           "questionInfo": {
    //             "questionIdentifier": "COUNTRY"
    //           },
    //           "field": "COUNTRY",
    //           "shouldBeCondition": "IN",
    //           "acceptedValues": []
    //         },
    //         {
    //           "type": "SINGLE",
    //           "questionInfo": {
    //             "questionIdentifier": "PARTNER_CERTIFICATION"
    //           },
    //           "field": "PARTNER_CERTIFICATION",
    //           "shouldBeCondition": "IN",
    //           "acceptedValues": []
    //         },
    //         {
    //           "type": "SINGLE",
    //           "questionInfo": {
    //             "questionIdentifier": "PARTNER_SPECIALIZATION"
    //           },
    //           "field": "PARTNER_SPECIALIZATION",
    //           "shouldBeCondition": "IN",
    //           "acceptedValues": []
    //         },
    //         {
    //           "type": "SINGLE",
    //           "questionInfo": {
    //             "questionIdentifier": "BEGEOID"
    //           },
    //           "field": "BEGEOID",
    //           "shouldBeCondition": "IN",
    //           "acceptedValues": []
    //         },
    //         {
    //           "type": "SINGLE",
    //           "questionInfo": {
    //             "questionIdentifier": "USER_ROLE"
    //           },
    //           "field": "USER_ROLE",
    //           "shouldBeCondition": "IN",
    //           "acceptedValues": []
    //         },
    //         {
    //           "type": "SINGLE",
    //           "questionInfo": {
    //             "questionIdentifier": "CLAIMS_LIMIT"
    //           },
    //           "field": "CLAIMS_LIMIT",
    //           "shouldBeCondition": "LESSER_THAN_OR_EQUAL_TO",
    //           "acceptedValues": []
    //         },
    //         {
    //           "type": "SINGLE",
    //           "questionInfo": {
    //             "questionIdentifier": "SCMS"
    //           },
    //           "field": "SCMS",
    //           "shouldBeCondition": "IN",
    //           "acceptedValues": []
    //         },
    //         {
    //           "type": "SINGLE",
    //           "questionInfo": {
    //             "questionIdentifier": "SUB_SCMS"
    //           },
    //           "field": "SUB_SCMS",
    //           "shouldBeCondition": "IN",
    //           "acceptedValues": []
    //         },
    //         {
    //           "type": "SINGLE",
    //           "questionInfo": {
    //             "questionIdentifier": "END_CUSTOMER_ID"
    //           },
    //           "field": "END_CUSTOMER_ID",
    //           "shouldBeCondition": "IN",
    //           "acceptedValues": []
    //         },
    //         {
    //           "type": "SINGLE",
    //           "questionInfo": {
    //             "questionIdentifier": "TRAINING_ACTIVITY"
    //           },
    //           "field": "TRAINING_ACTIVITY",
    //           "shouldBeCondition": "IN",
    //           "acceptedValues": []
    //         },
    //         {
    //           "type": "GROUP",
    //           "logicalConditionBetweenChildCriterias": "OR",
    //           "criterias": [
    //             {
    //               "type": "GROUP",
    //               "criteriaPayout": {
    //                 "id": null,
    //                 "payAgainstType": null,
    //                 "payAsType": null,
    //                 "criteriaPayoutRanges": [],
    //                 "criteriaPayoutProductLevels": []
    //               },
    //               "logicalConditionBetweenChildCriterias": "AND",
    //               "criterias": [
    //                 {
    //                   "type": "SINGLE",
    //                   "questionInfo": {
    //                     "questionIdentifier": "TEMPLATED_CRITERIA"
    //                   },
    //                   "acceptedValues": []
    //                 }
    //               ]
    //             }
    //           ]
    //         }
    //       ]
    //     }
    //   }
    // })
  };

  submitCustomSalesChallenge(customeChallenge) {
    let challengeData = this.ciscoAdminChallenge.value;
    if(challengeData!=null && challengeData.editData!=null && !challengeData.editData.hasOwnProperty('copy')){
      return this.apiService.put(
        `${sellerApi.submitCustomChallenge}/${this.ciscoAdminChallenge.value.editData['id']}`,
        customeChallenge
      );
    }else{
      if(challengeData!=null && challengeData.editData!=null && challengeData.editData.copy) {
        customeChallenge.status = "DRAFT";
      }
      return this.apiService.post(
        `${sellerApi.submitCustomChallenge}`,
        customeChallenge
      );
    };
  };

  getTrainingActivityData(startDate, endDate, regions) {
    return this.apiService.get(
      `${sellerApi.activityChallenge}?startDate=${startDate}&endDate=${endDate}&challengeType=4&regions=${regions}`
    );
  };
}
